import request from "@/utils/request";

export default function agentUnBindRFIDCard(card) {
  return request({
    url: `/user/agent/RFIDCardController/unBindRFIDCard?id=${card}`,
    method: "post",
  });
}
